var imgixRefresh = function ($timeout, imgix) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {
            if (scope.$last === true) {
                imgix.reload();
                element[0].classList.add('has-loaded');
            }
            else {
                $timeout(() => {
                    imgix.reload();
                    element[0].classList.add('has-loaded');
                });
            }
        }
    };
};

imgixRefresh.$inject = ['$timeout', 'imgix'];

export default imgixRefresh;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/base/directives/imgix.refresh.directive.js